module.exports = __webpack_public_path__ + "img/tmf_top.912cc8a2.jpg";